var _defs, _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesCmsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-cms-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-cms-icon_svg__cls-1{fill:#e84b0f;stroke:#010101;stroke-miterlimit:10;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 20.06c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29C61.14 4.4 68.14 11.4 69 20.06z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-cms-icon_svg__cls-1",
    d: "M59.22 42.86c.27-1.58.39-3.16.39-4.83s-.15-3.25-.39-4.83h-5.1c-.61-2.88-1.76-5.59-3.31-7.99l3.61-3.61c-1.88-2.64-4.16-4.95-6.8-6.8l-3.61 3.61c-2.4-1.58-5.1-2.7-7.99-3.31V10c-1.58-.27-3.16-.39-4.83-.39s-3.25.15-4.83.39v5.1c-2.88.61-5.59 1.76-7.99 3.31l-3.58-3.61a29.136 29.136 0 00-6.83 6.83l3.61 3.61c-1.58 2.4-2.7 5.1-3.31 7.99H3.17c-.27 1.55-.39 3.16-.39 4.8s.15 3.25.39 4.83h5.1c.61 2.88 1.76 5.59 3.31 7.99l-3.61 3.58c1.85 2.64 4.16 4.95 6.8 6.8l3.61-3.61c2.4 1.58 5.1 2.7 7.99 3.31v5.1c1.58.27 3.19.39 4.83.39s3.25-.15 4.83-.39v-5.1c2.88-.61 5.59-1.76 7.99-3.31l3.61 3.61c2.64-1.85 4.95-4.16 6.8-6.8l-3.61-3.61c1.58-2.4 2.7-5.1 3.31-7.99h5.1v.03z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.19,
    cy: 38.03,
    r: 19.4,
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "websites-cms-icon_svg__cls-1",
    cx: 31.19,
    cy: 38.03,
    r: 4.13
  })));
}
export default SvgWebsitesCmsIcon;